module.exports = __webpack_public_path__ + "img/mobile-university-logo.46e2ca22.jpg";